
import { sortByDescending, length, ofArray, singleton as singleton_1, empty, isEmpty, filter, tryFind, choose, map } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { concat, join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { unwrap, bind, map as map_1, defaultArg } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { createElement } from "react";
import React from "react";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { empty as empty_1, singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { useTranslation } from "react-i18next";
import { saveChatConversation, loadChatConversation } from "./Storage.js";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, initPanel } from "../Chat/Overview/State.js";
import { useEffectWithDeps } from "../fable_modules/Feliz.2.9.0/ReactInterop.js";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { parse } from "../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { toString } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { Msg } from "../Chat/Overview/Types.js";
import { createDisposable } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { plusIcon, panelTitle, backIcon, PanelHeader, openPageIcon, PanelIconButton } from "./PanelHeader.js";
import { RouterModule_encodeQueryString, RouterModule_nav } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { isOverlayLayout } from "./Types.js";
import { compareArrays, int32ToString, createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { ConfirmationDialog } from "../Components/Dialog.js";
import { Input } from "../Components/Input.js";
import { ConversationListItem, ChatMessageArea, UserSelectionList } from "../Chat/Overview/View.js";
import { Button } from "../Components/Button.js";
import { Skeleton } from "../Components/Skeleton.js";
import { isUnread } from "../Chat/Overview/UnreadTracking.js";
import Help_Chat_2 from "../../public/assets/icons/Help_Chat_2.svg";

function conversationName(t, userId, users, conversation) {
    const matchValue = conversation.Name;
    if (matchValue == null) {
        const _arg_1 = map((_arg) => _arg.Name, choose((participantId) => tryFind((user) => (user.Id === participantId), users), filter((id) => (id !== userId), conversation.ParticipantUserIds)));
        if (isEmpty(_arg_1)) {
            return t("chat.unknown_user");
        }
        else {
            return join(", ", _arg_1);
        }
    }
    else {
        return matchValue;
    }
}

function lastActivity(conversation) {
    return defaultArg(map_1((_arg) => _arg.CreatedAt, conversation.LastMessage), conversation.CreatedAt);
}

function ConversationAvatar(props) {
    let copyOfStruct;
    return reactElement("div", {
        className: join(" ", toList(delay(() => append(singleton("w-8"), delay(() => append(singleton("h-8"), delay(() => append(singleton("shrink-0"), delay(() => append(singleton("bg-primary"), delay(() => append(singleton("flex"), delay(() => append(singleton("items-center"), delay(() => append(singleton("justify-center"), delay(() => append(singleton("text-white"), delay(() => append(singleton("text-sm"), delay(() => append(singleton("font-medium"), delay(() => (props.IsGroup ? singleton("rounded-lg") : singleton("rounded-full"))))))))))))))))))))))))),
        children: (props.Name.length > 0) ? ((copyOfStruct = props.Name[0], copyOfStruct)).toLocaleUpperCase() : "?",
    });
}

export function ChatPanel(props) {
    let elems_9;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const storedConversation = loadChatConversation(props.UserData.UserId);
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => initPanel(props.UserData, storedConversation), update_1, (_arg, _arg_1) => {
    }), undefined, [props.UserData.UserId]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    let patternInput_2;
    const initial = storedConversation != null;
    patternInput_2 = reactApi.useState(initial);
    const showThread = patternInput_2[0];
    const setShowThread = patternInput_2[1];
    useEffectWithDeps(() => {
        const hubUrl = concat(window.location.origin, "/hub/chat?userId=", ...props.UserData.UserId);
        const connection = (new HubConnectionBuilder()).withUrl(hubUrl).withAutomaticReconnect().build();
        connection.on("NewChatMessage", (rawConversationId) => {
            dispatch(new Msg(22, [parse(toString(rawConversationId))]));
        });
        let pr_1;
        const pr = connection.start();
        pr_1 = (pr.then(void 0, ((_arg_3) => {
        })));
        pr_1.then();
        return createDisposable(() => {
            let pr_3;
            const pr_2 = connection.stop();
            pr_3 = (pr_2.then(void 0, ((_arg_4) => {
            })));
            pr_3.then();
        });
    }, [props.UserData.UserId]);
    const dependencies_3 = [state_1.SelectedConversationId];
    reactApi.useEffect(() => {
        saveChatConversation(props.UserData.UserId, state_1.SelectedConversationId);
        setShowThread(state_1.SelectedConversationId != null);
    }, dependencies_3);
    let users_1;
    const matchValue = state_1.Users;
    users_1 = ((matchValue.tag === 0) ? empty() : matchValue.fields[0]);
    let conversations_1;
    const matchValue_1 = state_1.Conversations;
    conversations_1 = ((matchValue_1.tag === 0) ? empty() : matchValue_1.fields[0]);
    const activeConversation = bind((id) => tryFind((conversation) => (conversation.Id === id), conversations_1), state_1.SelectedConversationId);
    const openPageButton = createElement(PanelIconButton, {
        Icon: openPageIcon,
        Label: t("activity_bar.open_chat_page"),
        OnClick: () => {
            let conversationId_1;
            const matchValue_2 = state_1.SelectedConversationId;
            let matchResult, conversationId_2;
            if (matchValue_2 != null) {
                if ((conversationId_1 = matchValue_2, showThread)) {
                    matchResult = 0;
                    conversationId_2 = matchValue_2;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    RouterModule_nav(singleton_1("chat" + RouterModule_encodeQueryString(singleton_1(["conversationId", conversationId_2]))), 1, 1);
                    break;
                }
                case 1: {
                    RouterModule_nav(singleton_1("chat"), 1, 1);
                    break;
                }
            }
            if (isOverlayLayout()) {
                props.OnClose();
            }
        },
        TestId: "activity-panel-chat-open-page",
    });
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "h-full", "min-h-0"])], (elems_9 = toList(delay(() => {
        let Title;
        return append(singleton(createElement(ConfirmationDialog, (Title = t("chat.delete_message"), {
            Description: t("chat.confirm_delete_message"),
            IsOpen: state_1.MessageToDelete != null,
            OnClose: () => {
                dispatch(new Msg(47, []));
            },
            OnConfirm: () => {
                dispatch(new Msg(46, []));
            },
            Title: Title,
        }))), delay(() => {
            let elems, elems_4, elems_3, Title_3, conversation_1;
            if (state_1.IsNewChatOpen) {
                return append(singleton(createElement(PanelHeader, {
                    Actions: empty(),
                    OnClose: props.OnClose,
                    TestId: "activity-panel-chat",
                    Title: reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-1", "min-w-0", "-ml-2"])], (elems = [createElement(PanelIconButton, {
                        Icon: backIcon,
                        Label: t("general.back"),
                        OnClick: () => {
                            dispatch(new Msg(10, []));
                        },
                        TestId: "activity-panel-chat-back",
                    }), panelTitle(t("chat.new_chat"))], ["children", reactApi.Children.toArray(Array.from(elems))])]))),
                })), delay(() => {
                    let elems_1;
                    return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["px-4", "pt-3", "pb-2"])], (elems_1 = [createElement(Input, {
                        ComponentState: "enabled",
                        OnChange: (value_5) => {
                            dispatch(new Msg(14, [value_5]));
                        },
                        TestId: "activity-panel-chat-user-search",
                        Value: state_1.NewChatSearchTerm,
                    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => append(singleton(createElement(UserSelectionList, {
                        CurrentUserId: props.UserData.UserId,
                        Dispatch: dispatch,
                        ExcludeUserIds: empty(),
                        SearchTerm: state_1.NewChatSearchTerm,
                        SelectedUserIds: state_1.NewChatSelectedUserIds,
                        Users: users_1,
                    })), delay(() => {
                        let elems_2, arg_1;
                        return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "justify-between", "gap-2", "px-4", "py-3", "border-t", "border-border", "shrink-0"])], (elems_2 = [reactElement("span", {
                            className: join(" ", ["text-xs", "text-text-muted"]),
                            children: (arg_1 = {
                                count: length(state_1.NewChatSelectedUserIds),
                            }, patternInput[1].t("activity_bar.selected_users", arg_1)),
                        }), createElement(Button, {
                            ComponentState: isEmpty(state_1.NewChatSelectedUserIds) ? "disabled" : "enabled",
                            Label: t("chat.start_chat"),
                            OnClick: () => {
                                dispatch(new Msg(16, []));
                            },
                            TestId: "activity-panel-chat-start",
                            Variant: "primary",
                        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
                    }))));
                }));
            }
            else {
                const matchValue_3 = activeConversation;
                let matchResult_1, conversation_2;
                if (matchValue_3 != null) {
                    if ((conversation_1 = matchValue_3, showThread)) {
                        matchResult_1 = 0;
                        conversation_2 = matchValue_3;
                    }
                    else {
                        matchResult_1 = 1;
                    }
                }
                else {
                    matchResult_1 = 1;
                }
                switch (matchResult_1) {
                    case 0: {
                        const name_4 = conversationName(t, props.UserData.UserId, users_1, conversation_2);
                        return append(singleton(createElement(PanelHeader, {
                            Actions: singleton_1(openPageButton),
                            OnClose: props.OnClose,
                            TestId: "activity-panel-chat",
                            Title: reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2", "min-w-0", "-ml-2"])], (elems_4 = [createElement(PanelIconButton, {
                                Icon: backIcon,
                                Label: t("activity_bar.back_to_conversations"),
                                OnClick: () => {
                                    setShowThread(false);
                                    dispatch(new Msg(4, []));
                                },
                                TestId: "activity-panel-chat-back",
                            }), createElement(ConversationAvatar, {
                                IsGroup: conversation_2.IsGroup,
                                Name: name_4,
                            }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "min-w-0"])], (elems_3 = toList(delay(() => append(singleton(reactElement("span", {
                                "data-test-id": "activity-panel-chat-conversation-name",
                                className: join(" ", ["font-semibold", "text-sm", "truncate"]),
                                children: name_4,
                            })), delay(() => (conversation_2.IsGroup ? singleton(reactElement("span", {
                                className: join(" ", ["text-xs", "text-text-muted"]),
                                children: (int32ToString(length(conversation_2.ParticipantUserIds)) + " ") + t("chat.members"),
                            })) : empty_1()))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))),
                        })), delay(() => singleton(createElement(ChatMessageArea, {
                            Dispatch: dispatch,
                            FormState: state_1.FormState,
                            HasPendingImage: state_1.PendingImage != null,
                            IdPrefix: "panel-",
                            ImagePreviewUrl: unwrap(state_1.ImagePreviewUrl),
                            IsDragOver: state_1.IsDragOver,
                            Messages: state_1.Messages,
                            NewMessage: state_1.NewMessage,
                            UserId: props.UserData.UserId,
                            UserName: props.UserData.UserName,
                        }))));
                    }
                    default:
                        return append(singleton(createElement(PanelHeader, (Title_3 = panelTitle(t("activity_bar.chat")), {
                            Actions: ofArray([createElement(PanelIconButton, {
                                Icon: plusIcon,
                                Label: t("chat.new_chat"),
                                OnClick: () => {
                                    dispatch(new Msg(9, []));
                                },
                                TestId: "activity-panel-chat-new",
                            }), openPageButton]),
                            OnClose: props.OnClose,
                            TestId: "activity-panel-chat",
                            Title: Title_3,
                        }))), delay(() => {
                            let elems_8;
                            return singleton(reactElement("div", createObj(ofArray([["data-test-id", "activity-panel-chat-conversations"], ["className", join(" ", ["flex-1", "min-h-0", "overflow-y-auto"])], (elems_8 = toList(delay(() => {
                                let elems_7, elems_6, elems_5;
                                const matchValue_4 = state_1.Conversations;
                                return (matchValue_4.tag === 0) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["p-4"])], (elems_7 = [createElement(Skeleton, {
                                    Variant: "normal",
                                })], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))) : (!isEmpty(matchValue_4.fields[0]) ? map((conversation_4) => createElement(ConversationListItem, {
                                    Conversation: conversation_4,
                                    IsSelected: false,
                                    IsUnread: isUnread(props.UserData.UserName, state_1.LastReadMap, conversation_4),
                                    OnClick: () => {
                                        dispatch(new Msg(3, [conversation_4.Id]));
                                        setShowThread(true);
                                    },
                                    Users: users_1,
                                }), sortByDescending((conversation_3) => [isUnread(props.UserData.UserName, state_1.LastReadMap, conversation_3), lastActivity(conversation_3)], matchValue_4.fields[0], {
                                    Compare: (x, y) => (compareArrays(x, y) | 0),
                                })) : singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "items-center", "justify-center", "gap-3", "h-full", "p-6", "text-center"])], (elems_6 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-12", "w-12", "text-text-muted"])], (elems_5 = [Help_Chat_2()], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), reactElement("span", {
                                    className: join(" ", ["text-sm", "text-text-muted"]),
                                    children: t("chat.no_conversations"),
                                }), createElement(Button, {
                                    ComponentState: "enabled",
                                    Label: t("chat.new_chat"),
                                    OnClick: () => {
                                        dispatch(new Msg(9, []));
                                    },
                                    TestId: "activity-panel-chat-new-empty",
                                    Variant: "primary",
                                })], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))));
                            })), ["children", reactApi.Children.toArray(Array.from(elems_8))])]))));
                        }));
                }
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_9))])])));
}

